
webpack.register(
    'blocks/leaderboard-drawer/scorecard/scorecard',
    function() {
        return import('blocks/leaderboard-drawer/scorecard/scorecard');
    },
    true
);